import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _ from 'lodash';
import UploadFileService from '@/services/upload-file.service';
export default {
  name: 'CreationThirdStep',
  props: {
    existing: {
      type: [Object, Array],
      required: false,
      default: function _default() {
        return {};
      }
    },
    nextStep: {
      type: Function,
      required: true
    },
    previousStep: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      processingAuthorImageUrl: false,
      seriesDiretor: null,
      seriesScript: null,
      seriesStarring: null,
      seriesYear: null,
      authorImageUrl: null,
      authorName: null,
      authorBio: null,
      authors: [],
      reRender: 0
    };
  },
  computed: {
    dataFormat: function dataFormat() {
      var format = {
        production: {
          director: this.seriesDiretor,
          script: this.seriesScript,
          starring: this.seriesStarring,
          year: Number(this.seriesYear)
        },
        authors: this.authors
      };
      return format;
    },
    isNextStepDisabled: function isNextStepDisabled() {
      return !(this.seriesDiretor && this.seriesScript && this.seriesStarring && this.seriesYear && this.authors[0]);
    }
  },
  beforeMount: function beforeMount() {
    var _this$existing;

    if ((_this$existing = this.existing) !== null && _this$existing !== void 0 && _this$existing.id) {
      this.seriesDiretor = this.existing.production.director;
      this.seriesScript = this.existing.production.script;
      this.seriesStarring = this.existing.production.starring;
      this.seriesYear = this.existing.production.year;
      this.authors = this.existing.authors ? _.cloneDeep(this.existing.authors) : [];
    }
  },
  methods: {
    loadAuthorImageFile: function loadAuthorImageFile(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.processingAuthorImageUrl = true;
                _context.next = 3;
                return UploadFileService.uploadFile(data).then(function (filename) {
                  _this.authorImageUrl = filename.url;
                  _this.processingAuthorImageUrl = false;
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addAuthor: function addAuthor() {
      var author = {
        authorName: this.authorName,
        description: this.authorBio,
        photoUrl: this.authorImageUrl
      };
      this.authors.push(author);
      this.authorName = null;
      this.authorBio = null;
      this.authorImageUrl = null;
      this.reRender += 1;
    },
    removeAuthor: function removeAuthor(name) {
      this.authors = this.authors.filter(function (author) {
        return author.authorName !== name;
      });
    }
  }
};